module.exports = __webpack_public_path__ + "static/media/lv.d84cff4c.svg";